import { api } from "../utils/api";
import UserStore from "../utils/UserStore";

const getRoles = async (includeSystem = true) => {
  const response = await api.get("AclWaybee/role", {
    params: { includeSystem }
  });
  return response.data;
};

const getAppRoles = async () => {
  const response = await api.get("AclWaybee/app-roles");
  return response.data;
};

const getPermissions = async () => {
  const response = await api.get("AclWaybee/permission");
  return response.data;
};

const getRolePermissions = async roleId => {
  const response = await api.get(`AclWaybee/${roleId}/rolePermissions`);
  return response.data;
};

const saveRole = async data => {
  const response = await api.post("AclWaybee/role", data);
  return response.data;
};

const updateRole = async data => {
  const response = await api.post("AclWaybee/role/update", data);
  return response.data;
};

const deleteRole = async roleId => {
  const response = await api.put(`AclWaybee/role/${roleId}/delete`);
  return response.data;
};

const getClasses = async () => {
  const response = await api.get("ClassDiaryV1/class", {
    params: {
      externalData: UserStore.getUserExternalInfo()
    }
  });
  return response.data;
};

const getClassRoles = async classId => {
  const response = await api.get("AclWaybee/class-roles", {
    params: { classId }
  });
  return response.data;
};

const saveClassRoles = async data => {
  const response = await api.put("AclWaybee/class-roles", data);
  return response.data;
};

const AclManagementService = {
  getRoles,
  getAppRoles,
  getPermissions,
  getRolePermissions,
  saveRole,
  updateRole,
  deleteRole,
  getClasses,
  getClassRoles,
  saveClassRoles
};

export default AclManagementService;
